import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Contact } from '../model/contact';
import { FormControl } from '@angular/forms';
import { Log } from '../util/log';

@Component({
  selector: 'app-add-contact-dialog',
  templateUrl: './add-contact-dialog.component.html',
  styleUrls: ['./add-contact-dialog.component.css']
})
export class AddContactDialogComponent implements OnInit, AfterViewInit {

  prefixFormControl: FormControl;
  numberFormControl: FormControl;
  error: boolean = false;

  constructor(public dialogRef: MatDialogRef<AddContactDialogComponent>) { 

    this.numberFormControl = new FormControl();
    this.prefixFormControl = new FormControl();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.prefixFormControl.setValue("39");
    });
  }

  closeAddContactDialog( ) {

    this.dialogRef.close();
  }

  addContact() {

    let number: number = this.numberFormControl.value;
    let prefix: string = this.prefixFormControl.value;

    Log.debug("number: " + number);
    Log.debug("prefix: " + prefix);

    if (!number || number.toString().length < 3) {
      this.error = true;
    }
    else if (!prefix || prefix.length < 1) {
      this.error = true;
    }
    else {
      this.error = false;
      this.dialogRef.close(new Contact(prefix, number.toString()));
    }
  }

}
